import React, { useMemo } from 'react';
import { StatTile } from '@aibuild/ui';
import type { ProcessNode, ProcessEdge } from '../graphTypes';
import { InfoGrid } from './CanvasInfoCard.styled';

export interface CanvasInfoCardProps {
  nodes: ProcessNode[];
  edges: ProcessEdge[];
  dataTestId?: string;
}

const CanvasInfoCard: React.FC<CanvasInfoCardProps> = ({
  nodes,
  edges,
  dataTestId = 'canvas-info-card',
}) => {
  const stats = useMemo(() => {
    const inputCount = nodes.filter((n) => n.type === 'input').length;
    const outputCount = nodes.filter((n) => n.type === 'output').length;
    return {
      nodes: nodes.length,
      connections: edges.length,
      inputs: inputCount,
      outputs: outputCount,
    };
  }, [nodes, edges]);

  return (
    <InfoGrid data-testid={dataTestId} aria-label="Canvas stats">
      <StatTile
        value={stats.nodes}
        label="Nodes"
        align="center"
        size="sm"
        labelTransform="none"
        dataTestId={`${dataTestId}__nodes`}
      />
      <StatTile
        value={stats.connections}
        label="Connections"
        align="center"
        size="sm"
        labelTransform="none"
        dataTestId={`${dataTestId}__connections`}
      />
      <StatTile
        value={stats.inputs}
        label="Inputs"
        align="center"
        size="sm"
        labelTransform="none"
        dataTestId={`${dataTestId}__inputs`}
      />
      <StatTile
        value={stats.outputs}
        label="Outputs"
        align="center"
        size="sm"
        labelTransform="none"
        dataTestId={`${dataTestId}__outputs`}
      />
    </InfoGrid>
  );
};

export default CanvasInfoCard;
